(function($) {
	$(() => {
		let libraryLoaded = false;
		let libraryIsLoading = false;

		const fetchLib = (callback) => {
			if(!libraryLoaded){
				if(!libraryIsLoading){
					libraryIsLoading = true;
					window.fetchInject([
						fr_js_vars.vendor_css_base_url + 'richtext.min.css',
                        'https://kit.fontawesome.com/8850b489f7.js',
						fr_js_vars.vendor_js_base_url + 'jquery.richtext.min.js',
					]).then(() => {
						libraryLoaded = true;
						if(callback) callback();
					});
				}
			}else{
				if(callback) callback();
			}
		}

		$(window).on('fr:load-richtextjs', (ev) => {
			fetchLib(() => {
				$(window).trigger('fr:richtextjs-loaded');
			});
		});
	});
})(jQuery);